module.exports = __webpack_public_path__ + "96d264bd9deb126e6a8095e381997b8c.svg";